import { FC } from 'react'
import { Box, PageTitle } from '@perk-ui/core'

// import { ArrowLeft } from 'react-feather'
import { useSitesContext } from '../../components/SitesProvider'
import TableauView from '../../components/TableauView'
import { useUser } from '../../features/auth/AuthContext'
// import { useHistory } from '../../utils/useHistory'

export interface QuickStatsProps {}

// const useStyles = makeStyles((theme) => ({

// }))

const QuickStats: FC<QuickStatsProps> = () => {
  const sitesContext = useSitesContext()
  // const { goBack } = useHistory()
  const currentUser = useUser()
  const site = sitesContext.currentSite
  const staffTableauSubscription = currentUser?.staff.subscriptionPlan

  const pageTitle = 'Quick Stats'

  if (!site) return null

  const getWorkbookUrl = () => {
    switch (staffTableauSubscription) {
      case 'performance_rsx_ebm':
      case 'performance_rsx_registry':
      case 'performance_rsx_ebm_registry':
      case 'performance_rsx':
      case 'performance':
      case 'performance_registry':
      case 'performance_ebm_registry':
      case 'performance_ebm':
        return 'views/quick_stats/QuickStatsScorecard'
      case 'starter':
      case 'demo':
      case 'essentials':
      default:
        return ''
    }
  }

  const QuickStatsTableauParameters = [
    {
      key: 'parameter_select_subscription_type',
      value: 'IMPACT',
    },
    // {
    //   key: 'parameter_select_site_id',
    //   value: site?.id,
    // },
    // {
    //   key: 'parameter_select_provider_id',
    //   value: currentUser?.staff?.id,
    // },
  ]

  return (
    <Box p={3}>
      <PageTitle title={pageTitle} />
      {/* <Box display="flex" alignItems={'center'} p={2}>
        <IconButton onClick={() => goBack()}>
          <ArrowLeft />
        </IconButton>
        <H3>Quick Stats</H3>
      </Box> */}
      {getWorkbookUrl() !== '' && (
        <TableauView
          src={getWorkbookUrl()}
          toolbar="top"
          hideTabs={false}
          parameters={QuickStatsTableauParameters}
          section="quick-stats"
        />
      )}
    </Box>
  )
}

export default QuickStats
